import { add, format } from 'date-fns';

export function formatContentfulDate(value: string | null | undefined, pattern: string) {
  if (!value) return '';
  return format(add(new Date(value), { hours: 8 }), pattern);
}
